export default __webpack_public_path__ + "static/media/profile.5f3b8e69.jpg";